<template>
    <v-dialog
        v-model="editModal"
        eager
    >
        <ValidationObserver
            ref="observer"
            v-slot="{ handleSubmit, invalid }"
        >
            <v-card class="MediaModal">
                <ModalOverlay />
                <v-card-title class="MediaModal__header">
                    <h1>Edit Media</h1>
                    <v-spacer />
                    <v-btn
                        type="button"
                        text
                        @click="closeEditModal()"
                    >
                        Close
                    </v-btn>
                    <v-btn
                        form="editMediaForm"
                        type="submit"
                        color="primary"
                        :disabled="invalid"
                    >
                        <v-icon
                            small
                            left
                        >
                            fas fa-save
                        </v-icon>
                        Save
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col
                            cols="12"
                            md="4"
                        >
                            <v-img
                                v-if="currentSrc"
                                height="250"
                                :src="currentSrc"
                                cover
                                class="MediaModal__preview"
                            >
                                <template #placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        />
                                    </v-row>
                                </template>
                            </v-img>
                        </v-col>
                        <v-col
                            cols="12"
                            md="8"
                        >
                            <form
                                @submit.prevent="handleSubmit(edit)"
                                id="editMediaForm"
                            >
                                <TagMedia />
                            </form>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </ValidationObserver>
    </v-dialog>
</template>

<script>
import MediaCrudMixin from '@/views/Admin/MediaLibrary/MediaCrudMixin';
import ModalOverlay from '@/components/ModalOverlay';
import store from '@/store/store';
import { mapActions } from 'vuex';
import TagMedia from '@/views/Admin/MediaLibrary/TagMedia';

export default {
    components: {TagMedia, ModalOverlay },
    mixins: [ MediaCrudMixin ],

    computed: {
        editModal: {
            get: function() {
                return store.state.mediaLibrary.editModal;
            },
            set: function(value) {
                this.toggleEditModal(value);
            }
        },

        currentSrc: {
            get: function() {
                return store.state.mediaLibrary.currentSrc;
            },
            set: function(value) {
                this.setCurrentSrc(value);
            }
        },
    },

    methods: {
        ...mapActions({
            editMedia: 'mediaLibrary/editMedia',
        }),

        edit() {
            this.toggleOverlay(true);
            this.editMedia()
                .then(() => {
                    this.closeEditModal();
                });
        },

        closeEditModal() {
            this.setCurrentSrc('');
            this.setSelectedFields([]);
            this.setProfession([]);
            this.setMediaId('');
            this.toggleEditModal(false);
        }
    }
};
</script>
